var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { GoodDamageComponent } from '../GoodDamageComponent';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import LengthInput from '@declaration/components/LengthInput.vue';
import { PIPE_TYPE_CHOICES } from '@shared/roomDamage/goodDamage';
import { PipeType } from '@shared/types/api/roomDamage';
let VisiblePipesDescription = class VisiblePipesDescription extends GoodDamageComponent {
    get pipeTypeLabel() {
        return this.$tc('claim.damage.real_estate.room_damage.form.question.good_damage.plumbing.visible_pipes.pipe_type');
    }
    get lengthLabel() {
        return this.$tc('claim.damage.real_estate.room_damage.form.question.good_damage.plumbing.visible_pipes.length');
    }
    get pipeTypeChoices() {
        return PIPE_TYPE_CHOICES;
    }
    get pipeType() {
        var _a, _b;
        return (_b = (_a = this.goodDamage) === null || _a === void 0 ? void 0 : _a.pipeType) !== null && _b !== void 0 ? _b : null;
    }
    set pipeType(pipeType) {
        this.updateGoodDamage({
            pipeType,
            length: this.shouldProvideLength(pipeType) ? this.length : null,
        });
    }
    get length() {
        var _a, _b;
        return (_b = (_a = this.goodDamage) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : null;
    }
    set length(length) {
        this.updateGoodDamage({ length });
    }
    shouldProvideLength(type) {
        return ![PipeType.FLEXIBLE, null].includes(type);
    }
};
VisiblePipesDescription = __decorate([
    Component({ components: { RadioPrimaryButton, LengthInput } })
], VisiblePipesDescription);
export default VisiblePipesDescription;
